<template>
  <div class="photo-widget">
    <h2 v-if="title" class="photo-widget__heading" v-html="title"/>
    <img
      v-for="(photo, i) in photos"
      :key="i"
      :src="photo"
      :alt="description"
      class="photo-widget__img"
      :class="{ 'photo-widget__img--half': halfPhoto }"
    >
    <p
      v-if="photoDesc"
      class="photo-widget__description"
      :class="{ 'photo-widget__description--half': halfPhoto }"
      v-html="photoDesc"
    />
  </div>
</template>

<script>
export default {
  props: {
    photos: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ''
    },
    photoDesc: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    halfPhoto: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .photo-widget {
    @include vertical-space((bottom: 2));

    @include media-up(lg) {
      @include nested-column-width(8, 9, lg);
    }

    &__img {
      @include responsive-img;
      width: 100%;
    }

    &__description {
      @include theme(color);
      @include text(small);
      margin-top: 8px;

      /deep/ a {
        @include reset-link;
        text-decoration: underline;
      }
    }

    &__img--half,
    &__description--half {
      @include media-up(lg) {
        @include nested-column-width(4, 9, lg);
        padding-right: $grid-gutter / 2 + 2px;
      }
    }

    &__heading {
      @include vertical-space((bottom: 1));
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/PhotoWidget.vue